import { UtensilsCrossed, Car, Briefcase, Baby, Heart, MoreHorizontal } from 'lucide-react';

// Shared task-category vocabulary used by TaskCard and AddTaskDialog.
// Keep in sync with backend enum values for `Task.category`.
export const CATEGORIES = [
  { key: 'meals', label: 'Meals', icon: UtensilsCrossed, color: 'text-amber-600 bg-amber-50 dark:bg-amber-900/20' },
  { key: 'rides', label: 'Rides', icon: Car, color: 'text-blue-600 bg-blue-50 dark:bg-blue-900/20' },
  { key: 'admin', label: 'Admin', icon: Briefcase, color: 'text-purple-600 bg-purple-50 dark:bg-purple-900/20' },
  { key: 'childcare', label: 'Childcare', icon: Baby, color: 'text-pink-600 bg-pink-50 dark:bg-pink-900/20' },
  { key: 'emotional', label: 'Emotional', icon: Heart, color: 'text-rose-600 bg-rose-50 dark:bg-rose-900/20' },
  { key: 'other', label: 'Other', icon: MoreHorizontal, color: 'text-slate-600 bg-slate-50 dark:bg-slate-900/20' },
];

export const getCat = (key) => CATEGORIES.find((c) => c.key === key) || CATEGORIES[5];
